import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { ControlContainer, NgForm } from '@angular/forms';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
import { WorkflowComponent } from '../../workflow.component';


@Component({
    selector: 'send-workflow.component',
    templateUrl: './send-workflow.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class SendWorkflowComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.SendWorkflowVM = {} as models.SendWorkflowVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowMandatory: boolean = false;
  public isWorkflowOnSubscriber: boolean = false;

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private stepDetailsService: StepDetailsService, private workflow: WorkflowComponent) {
  }

  ngOnInit(): void {
    //Reset revision needed quando volta para o servico
    if (!this.isWorkflowOnSubscriber)
      this.cardData = { revisionNeeded: false, revisionReason: null } as models.SendWorkflowVM;
    else if (this.workflow.isReturn)
      this.cardData.revisionNeeded = true;
    else
      this.cardData.revisionNeeded = isNullOrUndefined(this.cardData.revisionNeeded) ? false : this.cardData.revisionNeeded.toString() == "true";

    this.stepDetailsService.emitNeedsRevisionChange(this.cardData.revisionNeeded);
  }
  ngOnDestroy(): void {
    this.stepDetailsService.emitNeedsRevisionChange(false);
  }

  public getWorkflowNeedsRevision(): models.SendWorkflowVM {
    return this.cardData;
  }
  getIsFinalSubmission() {
    return (this.isWorkflowMandatory && !this.isWorkflowOnSubscriber) || (!this.isWorkflowMandatory && this.isWorkflowOnSubscriber && !this.cardData.revisionNeeded)
  }
  getIsSubmitToSubscriber() {
    return !this.isWorkflowMandatory && !this.isWorkflowOnSubscriber;
  }
  getIsRevision() {
    return !this.isWorkflowMandatory && this.isWorkflowOnSubscriber && this.cardData.revisionNeeded;
  }

  changeRevisionNeeded() {
    this.cardData.revisionNeeded = !this.cardData.revisionNeeded;
    this.stepDetailsService.emitNeedsRevisionChange(this.cardData.revisionNeeded);
  }
}
